import { useDispatch } from "react-redux";

import Box from "@mui/material/Box";

import { footerItems } from "../../config/config.footer";
import { uiActions } from "../../store";
import classes from "./Footer.module.css";

const Footer = () => {
  const dispatch = useDispatch();

  const handleOpenFaq = () => {
    dispatch(uiActions.setShowFaq(true));
  };

  return (
    <Box
      sx={{
        backgroundColor: "background.main",
        px: 2,
        py: 1,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box className={classes["footer"]}>
        <div className={classes["data-sources-container"]}>
          <div className={classes["data-sources"]}>
            Federal Data
            <br />
            Sources Include
          </div>

          {footerItems.dataSources.map((dataItem) => {
            switch (dataItem.type) {
              case "image": {
                return (
                  <a
                    key={dataItem.name}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={dataItem.link}
                    title=""
                    data-bs-original-title={dataItem.desc}
                  >
                    <img
                      className={classes["footer-image"]}
                      src={dataItem.src}
                      alt={dataItem.name}
                    />
                  </a>
                );
              }
              case "text": {
                return (
                  <a
                    key={dataItem.name}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={dataItem.link}
                    title=""
                    data-bs-original-title={dataItem.desc}
                  >
                    <span className={classes["footer-text"]}>
                      {dataItem.name}
                    </span>
                  </a>
                );
              }
              default: {
                return (
                  <a
                    key={dataItem.name}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={dataItem.link}
                    title=""
                    data-bs-original-title={dataItem.desc}
                  >
                    <span className={classes["footer-text"]}>
                      {dataItem.name}
                    </span>
                  </a>
                );
              }
            }
          })}
        </div>

        <div className={classes["text-button-container"]}>
          {footerItems.textButtons.map((textItem) => (
            <a
              key={textItem.name}
              target="_blank"
              rel="noopener noreferrer"
              href={textItem.link}
              title=""
              data-bs-original-title={textItem.desc}
            >
              <span className={classes["footer-text"]}>{textItem.name}</span>
            </a>
          ))}
          <span
            className={`${classes[("footer-text", "faq-button")]}`}
            onClick={handleOpenFaq}
          >
            FAQ
          </span>
        </div>
      </Box>
    </Box>
  );
};

export default Footer;
